import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import {
  pagingVoucherSync
} from "app/services/VoucherService";
import { PageResponse } from "app/common/Model/Shared";
import { syncListFeeToCrm } from "app/services/SyncCRMService";

export default class FeeAsyncStore {
  searchVoucherFee = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  selectFeetAsync = [];
  resetSelectedRows = false;

  pageFeeCard = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearch = (search) => {
    this.searchVoucherFee = { ...this.searchVoucherFee, ...search };
    this.getDataVoucherTotalCategory();
  };

  setSelectFeeAsync = (list) => {
    this.selectFeetAsync = list;
  };

  getDataVoucherTotalCategory = async () => {
    let { departmentId, ...ortherData } = this.searchVoucherFee;
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await pagingVoucherSync({ ...ortherData })
      .then(({ data }) => {
        this.pageFeeCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hóa đơn có lỗi");
      });
  };

  syncListFeeToCrm = async () => {
    const voucherIds = this.selectFeetAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncListFeeToCrm(voucherIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ Thanh toán thành công");
          this.getDataVoucherTotalCategory();
        } else {
          toast.error("Đồng bộ Thanh toán có lỗis");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error("123", error);
        toast.error("Đồng bộ Thanh toán có lỗi");
      });
  };

  resetStore = () => {
    this.searchVoucherFee = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
  };
}
